import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import CommentsCount from '../components/commentsCount';
import classNames from 'classnames';
import '../scss/_listingButtons.scss';
import { eventView } from '../components/GoogleAnalytics';
import LoginModal from './LoginModal';

class ListingButtons extends Component {
    constructor(...args) {
        super(...args);
        this.state = {
            selectedInterest: null,
            favorite_tooltipOpen: false,
            rejected_tooltipOpen: false,
            maybe_tooltipOpen: false,
            chat_tooltipOpen: false,
            showLoginModal: false,
            extraButtonActions_tooltipOpen: {}
        };
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.initializeExtraActionsStates(this.props.listing.ExtraButtonActions);
    }

    componentWillReceiveProps(nextProps) {
        // if button pressed on map
        if (this.props.listing.InterestLevel !== nextProps.listing.InterestLevel)
            this.setState({ selectedInterest: null });
        else if (this.props.listing.Id !== nextProps.listing.Id) {
            this.setState({
                selectedInterest: null,
                favorite_tooltipOpen: false,
                rejected_tooltipOpen: false,
                maybe_tooltipOpen: false,
                chat_tooltipOpen: false
            });
        }
    }

    handleButtonClick(interestLevel) {
        const { publicPortal, listing, onInterestLevelChange, listingActions, activityActions } = this.props;

        if (publicPortal || window.location.pathname.includes("public")) {
            this.toggle("showLoginModal")
            return
        }

        if (listing.InterestLevel === interestLevel)
            interestLevel = null;

        this.setState({ selectedInterest: interestLevel });
        window.sessionStorage.setItem("PreventMapMarkerPopupClose",true);

        listingActions.interestLevelSave(listing.Id, interestLevel).then((res) => {
            if (res.type !== 'INTERESTLEVEL_FAILURE') {
                listingActions.addListingToEntities({...listing, InterestLevel: interestLevel });

                // If activityActions and listing.Activityid are both present then update the entity
                // This is used on the Dashboard feed
                if (listing.ActivityId !== null && activityActions !== undefined) {
                    activityActions.fetchSingleActivity(listing.ActivityId);
                }

                // Register Interest Action with GA
                switch (interestLevel) {
                    case 'Y':
                        eventView('User','SetListingFavorite');
                        break;
                    case 'M':
                        eventView('User','SetListingMaybe');
                        break;
                    case 'N':
                        eventView('User','SetListingNotInterested');
                        break;
                    default:
                        break;
                }
            }
            if (onInterestLevelChange)
                onInterestLevelChange();
        });
    }

    toggle = (key) => {
        this.setState({ [key]: !this.state[key] })
    }


    handleCommentClick = (id) => {
        const { publicPortal, onCommentsClick } = this.props
        if (publicPortal || window.location.pathname.includes("public"))
            this.toggle("showLoginModal")
        else
            onCommentsClick(id)
    }

    initializeExtraActionsStates(actions) {
        const actionStates = {};
        actions.forEach(action => {
            actionStates[`${action.label}_tooltipOpen`] = false;
        });
        this.setState({ extraButtonActions_tooltipOpen: actionStates });
    }

    toggleExtraTooltip = (key) => {
        this.setState((prevState) => ({
            extraButtonActions_tooltipOpen: {
                ...prevState.extraButtonActions_tooltipOpen,
                [key]: !prevState.extraButtonActions_tooltipOpen[key]
            }
        }));
    };

    render() {
        const { listing, commentsBarOpen, isListView, showMap, bgClass, listViewTable, showExtraButtons = true } = this.props;
        const { InterestLevel:interestLevel } = listing;
        const { selectedInterest } = this.state;
        var displayInterest = null
        if (selectedInterest)
            displayInterest = selectedInterest;
        else if (interestLevel)
            displayInterest = interestLevel;

        return (
        <>
            <LoginModal {...this.props} open={this.state.showLoginModal} onClose={() => this.toggle("showLoginModal")} listingID={this.props.listing.Id} fromContact={Boolean(this.props.listingAgent)} />

            <div className="listing_buttons_container">
                <div className={classNames("listing_buttons", {[bgClass]: bgClass, "list-view": isListView && !showMap})}>
                {showExtraButtons && listing.ExtraButtonActions?.map((action, index) => (<>
                    <span tabIndex="0" role="button" key={index}
                          id={`${action.label}_${listing.Id}${this.props.isModal ? '_modal' : ''}`}
                          className={classNames(`imgicon ${action.icon}`)}
                          aria-label={action.alt}
                          onClick={() => window.open(action.link)}/>
                    <span className="listing_buttons_label">${action.label}</span>
                    <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.extraButtonActions_tooltipOpen[`${action.label}_tooltipOpen`]} toggle={() => this.toggleExtraTooltip(`${action.label}_tooltipOpen`)} placement="top" target={`${action.label}_${listing.Id}${this.props.isModal ? '_modal' : ''}`}>
                        {action.alt}
                    </Tooltip>
                </>))}
                    <span tabIndex="0" role="button" id={`favorite_${listing.Id}${this.props.isModal ? '_modal' : ''}`}
                        className={displayInterest === 'Y' ? 'imgicon heart selected' : 'imgicon heart'}
                        aria-label="Favorite"
                        onClick={() => this.handleButtonClick('Y')}
                        onKeyPress={(e) => { if (e.key === 'Enter') this.handleButtonClick('Y')}}
                    />
                    <span className="listing_buttons_label">Favorite</span>
                    <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.favorite_tooltipOpen} toggle={() => this.toggle('favorite_tooltipOpen')} placement="top" target={`favorite_${listing.Id}${this.props.isModal ? '_modal' : ''}`}>
                        {displayInterest === 'Y' ? 'Remove as Favorite' : 'Mark as Favorite'}
                    </Tooltip>
                    <span tabIndex="0" role="button" id={`rejected_${listing.Id}${this.props.isModal ? '_modal' : ''}`}
                        className={displayInterest === 'N' ? 'imgicon rejected selected' : 'imgicon rejected'}
                        aria-label="Not Interested"
                        onClick={() => this.handleButtonClick('N')}
                        onKeyPress={(e) => { if (e.key === 'Enter') this.handleButtonClick('N')}}
                    />
                    <span className="listing_buttons_label">Not Interested</span>
                    <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.rejected_tooltipOpen} toggle={() => this.toggle('rejected_tooltipOpen')} placement="top" target={`rejected_${listing.Id}${this.props.isModal ? '_modal' : ''}`}>
                        {displayInterest === 'N' ? 'Remove as Not Interested' : 'Mark as Not Interested'}
                    </Tooltip>
                    <span tabIndex="0" role="button" id={`maybe_${listing.Id}${this.props.isModal ? '_modal' : ''}`}
                        className={displayInterest === 'M' ? 'imgicon maybe selected' : 'imgicon maybe'}
                        aria-label="Maybe"
                        onClick={() => this.handleButtonClick('M')}
                        onKeyPress={(e) => { if (e.key === 'Enter') this.handleButtonClick('M')}}
                    />
                    <span className="listing_buttons_label">Maybe</span>
                    <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.maybe_tooltipOpen} toggle={() => this.toggle('maybe_tooltipOpen')} placement="top" target={`maybe_${listing.Id}${this.props.isModal ? '_modal' : ''}`}>
                        Maybe
                    </Tooltip>
                    {!this.props.hideComments &&
                        <span tabIndex="0" role="button" id={`chat_${listing.Id}${this.props.isModal ? '_modal' : ''}`}
                            className={classNames('imgicon chat', { 'selected': commentsBarOpen })}
                            aria-label="Comments"
                            onClick={() => { if (this.props.onCommentsClick) this.handleCommentClick(listing.Id) }}
                            onKeyPress={(e) => { if (e.key === 'Enter' && this.props.onCommentsClick) this.handleCommentClick(listing.Id) }}>
                        </span>
                    }
                    {!this.props.hideComments &&
                        <Tooltip delay={{ show: 0, hide: 0 }} isOpen={this.state.chat_tooltipOpen} toggle={() => this.toggle('chat_tooltipOpen')}
                            placement="top" target={`chat_${listing.Id}${this.props.isModal ? '_modal' : ''}`}>
                            Comment
                        </Tooltip>
                    }
                    {!this.props.hideComments &&
                        <CommentsCount listing={listing} />
                    }
                    {listViewTable &&
                        <button className="dyna-btn mg-lft-auto w-auto"
                            onClick={() => window.open(`/listing-details/${listing.Id}`)}>
                            View Details
                        </button>
                    }
                </div>
            </div>
        </>
        );
    }
}

export default ListingButtons;